import { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { updateFlightSearchObj } from '../../../../../store/slices/flight';

const RateCodePreferencesFilter = ({ tripId, variant, filterBgColor }) => {
  const isTripSearch = !tripId;
  const { travelAgency } = useSelector((state) => state.user);
  const { searchInputs } = useSelector(flightSearchInput(tripId, isTripSearch));
  const flightRateCodes = useSelector((store) => store.user.flightRateCodes);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const doHidePreferredFlightRateCodes = travelAgency && travelAgency.filterSettings
  && travelAgency.filterSettings.doHidePreferredFlightRateCodes;

  useEffect(() => {
    if (flightRateCodes && flightRateCodes.length) {
      setOptions(_.map(flightRateCodes, (r) => ({ value: r.rateCode, label: r.text && r.rateCode ? `${r.text} (${r.rateCode})` : r.rateCode || r.text })));
    }
  }, [flightRateCodes]);

  const handleChange = (newValue) => {
    const payload = {
      tripId,
      searchObj: {
        rateCodes: newValue,
        exactMatchRateCodesOnly: newValue.length === 0
          ? false : searchInputs.exactMatchRateCodesOnly,
        page: 1,
      },
    };

    if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
    else dispatch(updateFlightSearchObj(payload));
    track('rateCodePreferencesFilter.handleChange', {
      filterPreferences: JSON.stringify(newValue),
    });
  };
  return flightRateCodes && flightRateCodes.length && !doHidePreferredFlightRateCodes
    ? (
      <CheckboxSelectFilter
        options={options}
        values={(searchInputs && searchInputs.rateCodes) || []}
        onChange={handleChange}
        label="Rate Codes"
        widthInside="max-w-85"
        variant={isTripSearch ? undefined : variant}
        menuWidthClass="w-max"
        bgClassName={!isTripSearch ? '' : filterBgColor}
      />
    ) : <></>;
};

RateCodePreferencesFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterBgColor: PropTypes.string,
};

RateCodePreferencesFilter.defaultProps = {
  tripId: undefined,
  filterBgColor: undefined,
  variant: 'outline',
};

export default RateCodePreferencesFilter;
